import query from './query';
import store from './store';
import UDBUtils from './udb.common';
import pubsub from './pubsub';
import utils from './utils';
import h5sdkApi from './h5sdkApi';

/**
 * 登录工具类
 */
class Login {

    constructor() {
        this.searchStr = query.value;

        // 获取用户登录信息
        this.userInfo = this.getUserInfo();

	    this.udbUtils = new UDBUtils();
    }

	getUserInfo() {
		return {
			uid: store.cookie.get('yyuid') || store.cookie.get('udb_uid'),
			token: store.cookie.get('udb_biztoken'),
			origin: store.cookie.get('udb_origin'),
			version: store.cookie.get('udb_version'),
			passport: store.cookie.get('udb_passport'),
			nickname: store.cookie.get('nickname'),
			openid: store.cookie.get('partner_uid')
		}
	}

	refreshUserInfo() {
		this.userInfo = this.getUserInfo();
	}

    /**
     * 登录状态获取
     * @returns {boolean}
     */
    isLogin() {
	    let passport = this.userInfo.passport;
	    // 正则判断确保是通过微信账号登录
	    if(utils.isWx){
		    if(this.userInfo.uid && passport && /^qq_.*/g.test(passport)) {
			    return true;
		    }
	    }else{
		    if(this.userInfo.uid) {
			    return true;
		    }
	    }
        return false;
    }

    /**
     * 登录唤起,并返回登录态
     */
    toLogin() {
        if(!this.isLogin()) {
	        if(utils.isWx){
		        this.wechat();
	        }else{
		        pubsub.publish("showLogin");
	        }

            return false;
        }

        return true;
    }

	wechat() {
		let sHref = window.location.href;
		let params = {
			busiurl: sHref + '#redirectlogin',
			channel: this.searchStr.promoter || this.searchStr.channel || ''
		};
		this.udbUtils.wechat(params);
	}

	thirdLogin(params) {
		this.udbUtils.third(params);
	}

	accountLogin(params) {
		this.udbUtils.account(params);
	}

	verifyPhone(params) {
		this.udbUtils.verifyPhone(params);
	}

	getCode(params) {
		this.udbUtils.code(params);
	}

	register(params) {
		this.udbUtils.register(params);
	}

	logout(fn) {
		store.cookie.del('udb_uid');
		store.cookie.del('yyuid');
		this.udbUtils.logout(fn);
		fn && fn();
	}

	addCallback(type, fn) {
		if(type === 'reg') {
			this.udbUtils.addRegCallback(fn);
		}else{
			this.udbUtils.addLoginCallback(fn);
		}
	}

	clearCallback(type) {
		this.udbUtils.claer(type);
	}

    get user() {
        return this.userInfo;
    }
}

export default new Login();


// WEBPACK FOOTER //
// ./src/common/js/login.js